import gql from "graphql-tag";

export const GENERATE_INVOICES = gql(`
    mutation m($airline: String, $startDate: Date, $endDate: Date, $objectOption: Int) {
        invoiceService_generateInvoices(airline: $airline, startDate: $startDate, endDate: $endDate, objectOption: $objectOption)
    }`
);

export const REGENERATE_INVOICE_BASED_ON_LINES_OR_DATA = gql(`
    mutation m($invoiceId: Long, $regenerateLines: Boolean!) {
        invoiceService_regenerateInvoiceBasedOnLines(invoiceId: $invoiceId, regenerateLines: $regenerateLines)
    }`
);

export const REGENERATE_INVOICE_BASED_ON_TASKS = gql(`
    mutation m($invoiceId: Long) {
        invoiceService_regenerateInvoiceBasedOnTasks(invoiceId: $invoiceId)
    }`
);

export const GENERATE_CSV = gql(`
    query q($invoiceId: Long) {
        invoiceService_generateCSV(invoiceId: $invoiceId)
    }`
);

export const GET_UNIT_TYPES_OPTIONS = gql(`
    query q($invoiceId: Long) {
        invoiceService_unitTypesFromInvoice(invoiceId: $invoiceId)
    }`
);

export const GENERATE_PDF = gql(`
    query q($invoiceId: Long, $acceptedTaskTypes: [String]) {
        invoiceService_generatePDF(invoiceId: $invoiceId, acceptedTaskTypes: $acceptedTaskTypes)
    }`
);

export const EXPORT_AS_PDF_ALL_FILTERED_ROWS = gql(`
    query q($filter: FilterInput) {
        invoiceService_exportAsPDFAllFilteredRows(filter: $filter)
}`);

export const EXPORT_AS_CSV_ALL_FILTERED_ROWS = gql(`
    query q($filter: FilterInput) {
        invoiceService_exportAsCSVAllFilteredRows(filter: $filter)
}`);
